var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonationChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.914,
    height: 39.013,
    viewBox: "0 0 193.914 39.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7011",
    "data-name": "Group 7011",
    transform: "translate(0.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M-13282.733-9705.49l6.4-11.317,7.388,15.65,7.287-9.748,4.331,6.4,9.057-10.343h6.791l5.024-4.127,7.68-6.692,10.04,18.5,7.883-11.8,4.527,7.277,8.858-12.01,7.485,10.44,9.649,5.514,4.625-5.514,6.888-7.58,3.248-9.066,2.665,6.206,5.707,5.415,13.3,7.387,5.8-6.5,6.694-1.57,6.5-7.288,10.236,4.623,7.592-4.623,14.762-8.968",
    transform: "translate(13282.733 9739.206)",
    fill: "none",
    stroke: "#314c76",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 4.308,
    cy: 4.308,
    r: 4.308,
    transform: "translate(184.863)",
    fill: "#314c76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationChart);
export default __webpack_public_path__ + "static/media/donation-chart.bdaea6d1e3d2a7454b589e238a36c85e.svg";
export { ForwardRef as ReactComponent };